var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcOperaActive = function SvgIcOperaActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ic-opera-active_svg__ic-opera-active",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D92D37",
    d: "M10.733 25.017c-1.768-2.088-2.914-5.176-2.992-8.64v-.754c.078-3.464 1.224-6.552 2.992-8.64 2.296-2.98 5.708-4.87 9.518-4.87 2.344 0 4.538.716 6.413 1.96C23.847 1.553 20.134.015 16.061 0L16 0C7.163 0 0 7.163 0 16c0 8.58 6.755 15.583 15.238 15.981.253.012.507.019.762.019 4.097 0 7.833-1.54 10.663-4.072-1.876 1.244-4.068 1.96-6.412 1.96-3.81 0-7.222-1.89-9.518-4.871"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#932427",
    d: "M10.733 6.983c1.468-1.733 3.365-2.778 5.436-2.778 4.658 0 8.434 5.281 8.434 11.795s-3.776 11.795-8.434 11.795c-2.071 0-3.968-1.045-5.436-2.778 2.296 2.98 5.708 4.87 9.518 4.87 2.344 0 4.536-.715 6.412-1.959C29.938 24.998 32 20.741 32 16c0-4.74-2.061-8.997-5.336-11.927-1.875-1.244-4.069-1.96-6.413-1.96-3.81 0-7.222 1.89-9.518 4.87"
  }))));
};
export default SvgIcOperaActive;